export type Colors = "red" | "green" | "blue" | "yellow" | "purple" | "pink" | "gray";
const getBgColor200 = (color: Colors): string => {
  switch (color) {
    case "yellow":
      return "bg-yellow-200";
    case "blue":
      return "bg-blue-200";
    case "gray":
      return "bg-gray-200";
    case "green":
      return "bg-green-200";
    case "pink":
      return "bg-pink-200";
    case "purple":
      return "bg-pink-200";
    case "red":
      return "bg-red-200";
  }
};
const getBgColor400 = (color: Colors): string => {
  switch (color) {
    case "yellow":
      return "bg-yellow-400";
    case "blue":
      return "bg-blue-400";
    case "gray":
      return "bg-gray-400";
    case "green":
      return "bg-green-400";
    case "pink":
      return "bg-pink-400";
    case "purple":
      return "bg-pink-400";
    case "red":
      return "bg-red-400";
  }
};
const getTextColor800 = (color: Colors): string => {
  switch (color) {
    case "yellow":
      return "text-yellow-800";
    case "blue":
      return "text-blue-800";
    case "gray":
      return "text-gray-800";
    case "green":
      return "text-green-800";
    case "pink":
      return "text-pink-800";
    case "purple":
      return "text-pink-800";
    case "red":
      return "text-red-800";
  }
};

export const tailwindVars = {
  getTextColor800,
  getBgColor200,
  getBgColor400,
};
